import { addDays, addHours, format, parse } from 'date-fns';
export class DateUtil {
  /**
   * Convert string to date
   *
   * @param dateStr Date yyyy-MM-dd
   *
   * @returns {string}
   */
  static toDate(dateStr: string): Date | null {
    try {
      return parse(dateStr, 'yyyy-MM-dd', new Date());
    } catch (err) {
      return null;
    }
  }

  /**
   * Convert string to date
   *
   * @param dateStr Date yyyy-MM-dd
   *
   * @returns {string}
   */
  static toDatePtBr(dateStr: string): Date | null {
    const dateParse = parse(dateStr, 'dd/MM/yyyy', new Date());
    if (dateParse.isDate()) {
      return dateParse;
    }
    return null;
  }

  /**
   * Format date mask yyy-MM-dd
   *
   * @param date
   * @returns
   */
  static formatIso(date: number | Date) {
    return format(date, 'yyyy-MM-dd');
  }

  /**
   * Add days on date
   *
   * @param date Date
   * @param days days
   * @returns {Date}
   */
  static addDaysDate(date: Date, days: number): Date {
    return addDays(date, days);
  }

  /**
   * Add hours on date
   *
   * @param date Date
   * @param days days
   * @returns {Date}
   */
  static addHoursDate(date: Date, hours: number): Date {
    return addHours(date, hours);
  }

  /**
   * Subtract 3 hours from current date - GMT-3
   *
   * @returns {Date}
   */
  static getDateGMT3Offset(): Date | null {
    try {
      const date = new Date();
      return new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
    } catch (err) {
      return null;
    }
  }
  /**
   * Subtract 3 hours from date - GMT-3
   *
   * @returns {Date}
   */
  static toDateGMT3Offset(date: Date): Date | null {
    try {
      return new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
    } catch (err) {
      return null;
    }
  }
}
